// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Added Comment Lines
// MODIFIED DATE: 07-12-2025

import DemandFollowupActionTypes from './demand-followup-report.types';

/** ***************** GET LOAN DISBURSEMENT START *********************** */
export const getDemandFollowupDetailsStart = (getData: any) => ({
	type: DemandFollowupActionTypes.GET_DEMAND_FOLLOWUP_LIST_START,
	payload: getData,
});

export const getDemandFollowupDetailsSuccess = (successData: any) => ({
	type: DemandFollowupActionTypes.GET_DEMAND_FOLLOWUP_LIST_SUCCESS,
	payload: successData,
});

export const getDemandFollowupDetailsFailure = (failureData: any) => ({
	type: DemandFollowupActionTypes.GET_DEMAND_FOLLOWUP_LIST_FAILURE,
	payload: failureData,
});

export const getDemandFollowupDetailsResponseResetStart = () => ({
	type: DemandFollowupActionTypes.GET_DEMAND_FOLLOWUP_LIST_RESPONSE_RESET,
});

export const getDemandFollowupDetailsResponseChanged = () => ({
	type: DemandFollowupActionTypes.GET_DEMAND_FOLLOWUP_LIST_RESPONSE_CHANGED,
});

export const getDemandFollowupDetailsResponseArrayChanged = () => ({
	type: DemandFollowupActionTypes.GET_DEMAND_FOLLOWUP_LIST_RESPONSE_ARRAY_CHANGED,
});
/** ***************** GET DEMAND FOLLOWUP END *********************** */
